import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  DashboardAnalyticsContent,
  DashboardAnalyticsService,
  formatDashboardBrl,
  formatDashboardDeltaPercent,
  formatDashboardInteger,
} from 'src/app/modules/dashboard/services/dashboard-analytics.service';

@Component({
  selector: 'app-header-stats',
  templateUrl: './header-stats.component.html',
  styleUrls: ['./header-stats.component.scss'],
})
export class HeaderStatsComponent implements OnInit, OnDestroy {
  analytics: DashboardAnalyticsContent | null = null;
  loading = true;
  error: string | null = null;

  private sub?: Subscription;

  constructor(private dashboardAnalytics: DashboardAnalyticsService) {}

  ngOnInit(): void {
    this.sub = this.dashboardAnalytics.getAnalytics().subscribe({
      next: (data) => {
        this.analytics = data;
        this.loading = false;
        this.error = null;
      },
      error: (err: Error) => {
        this.error = err?.message ?? 'Indisponível';
        this.loading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  formatSales(value: number): string {
    return formatDashboardBrl(value);
  }

  formatInteger(value: number): string {
    return formatDashboardInteger(value);
  }

  formatDelta(changePercent: number): string {
    return formatDashboardDeltaPercent(changePercent);
  }
}
